import React from "react"
import { Flex } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

type Props = {
  /** Circular chevron glyph size (px). */
  glyphPx: number
}

/** Circular back control in the scan header — a filled chevron-circle glyph, white @ 80%. */
const KioskPreviewScanBackButton = ({ glyphPx }: Props) => (
  <Flex
    w={`${glyphPx}px`}
    h={`${glyphPx}px`}
    borderRadius="full"
    bg="rgba(255, 255, 255, 0.8)"
    align="center"
    justify="center"
    color="gray.800"
    flexShrink={0}
  >
    <Icon icon="prev-arrow" size={(glyphPx * 0.5) / 4} aria-hidden />
  </Flex>
)

export default KioskPreviewScanBackButton
